import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DeliveryStepsService } from '../../../services/delivery-steps.service';
import { ZipCodeRangeModel } from '../../../../shared/models/zip-code-range.model';
import { DistanceToDeadlineService } from '../../../services/distance-to-deadline.service';

@Component({
    selector: 'payment-delivery-freights-ready',
    templateUrl: './payment.delivery.freights.ready.component.html'
})
export class PaymentDeliveryFreightsReadyComponent implements OnInit {
    @Input() freight: ZipCodeRangeModel;
    @Output() selectedFreightReseted: EventEmitter<null> = new EventEmitter();

    public daysToDeadline: number;
    public daysToDeadlineLimit = 0;

    constructor(
        protected deliverySteps: DeliveryStepsService,
        protected distanceToDeadline: DistanceToDeadlineService
    ) {
        this.daysToDeadline = 0;
    }

    ngOnInit(): void {
        this.daysToDeadline = this.distanceToDeadline.calculate(this.freight.time_cost);
        if (this.hasDefinedLimit()) {
            this.daysToDeadlineLimit = this.distanceToDeadline.calculate(this.freight.time_cost_limit);
        }
    }

    /**
     * This reset selected freight property and emit reseted event.
     **/
    public resetSelectedFreight(): void {
        this.selectedFreightReseted.emit();
        this.deliverySteps.resetSelectedFreight();
        this.deliverySteps.loadFreights().subscribe();
    }
    /**
     * This verify if zipCodeRange has deadline_limit.
     **/
    public hasDefinedLimit(): boolean {
        if (null === this.freight.time_cost_limit) {
            return false;
        }

        const deadlineLimitDistance = this.distanceToDeadline.calculate(this.freight.time_cost_limit);
        const deadlineDistance = this.distanceToDeadline.calculate(this.freight.time_cost);
        const difference = (deadlineLimitDistance - deadlineDistance);

        return this.freight.time_cost_limit !== null && difference > 0;
    }
}



// WEBPACK FOOTER //
// /codebuild/output/src727013012/src/src/app/payment/delivery/freights/ready/payment.delivery.freights.ready.component.ts